import { Button, HStack } from '@chakra-ui/react'
import React from 'react'
import { Link } from 'react-router-dom'

export const Header = () => {
  return (
    <HStack p={'4'} shadow={'base'} bgColor={'blackAlpha.900'} color={'white'}>
        <Button variant={'unstyled'}>
            <Link to='/'>Home</Link>
        </Button>
        <Button variant={'unstyled'}>
            <Link to='/exchanges'>Exchanges</Link>
        </Button>
        <Button variant={'unstyled'}>
            <Link to='/coins'>Coins</Link>
        </Button>
    </HStack>
  )
};
